import anime from "animejs";

export default function () {
  let x = window.innerWidth;
  let y = window.innerWidth;
  const textBlock = document.querySelectorAll(".text-block");
  const hr = document.querySelector(".draw");
  const fade = document.querySelector(".fade-in");
  let i = 0;
  let top = "5vh";

  if (x > 992) {
    textBlock.forEach((block) => {
      i++;

      let delay;
      if (i >= 1) {
        delay = 500 * i;
      } else {
        delay = 0;
      }

      let moveIn = anime({
        targets: [block, hr, fade],
        translateX: "10px",
        opacity: [0, 1],
        duration: 1000,
        delay: delay,
        easing: "easeOutExpo",
      });
    });

    let drawLine = anime({
      targets: hr,
      width: ["0px", "193px"],
      duration: 600,
      delay: 850,
      easing: "easeOutExpo",
    });

    let fadeBtn = anime({
      targets: fade,
      opacity: [0, 1],
      translateY: "20px",
      top: "5vh",
      duration: 1000,
      delay: 1000,
    });
  }
}
